import { useNavigate } from 'react-router-dom';
import { APP_LINKS } from '@/helpers/links';
import { BackButton } from '@/components/BackButton';
import { Navigation } from './components/Navigation';
import s from './index.module.scss';

export const Layout = ({ children }) => {
  const navigate = useNavigate();
  return (
    <div className={s.layout}>
      <div className="container-inner">
        <BackButton onClick={() => navigate(APP_LINKS.loanTerms)} />
      </div>
      {children}
      <div className="container-inner">
        <div className={s.layout_bottom}>
          <h4 className="f-hero-h4">Explore other services</h4>
          <Navigation />
        </div>
      </div>
    </div>
  );
};